import React from 'react';
import { Popconfirm } from 'antd';
import Button from '@mui/material/Button';

const BasicPopconfirm = (props) => {

  return (
    <Popconfirm
        title={props.title}
        onConfirm={props.onConfirm}
        onVisibleChange={() => {}}
    >
        {
          props.button ? props.button :
          <Button style={{width: props.width ? props.width : ''}} variant='contained'>{props.label}</Button>
        }
    </Popconfirm>
  );
};

export default BasicPopconfirm;